import { createContext } from "react";

// Optional context shown after the SORU pane label ("SORU · BİYOLOJİ"). A screen
// that knows the question's subject wraps the activity renderer in the provider;
// every template picks it up through ActivitySolveLayout's PaneHead, so none of
// the per-template content components has to thread a prop. Unset = plain "SORU".
export const ActivityQuestionLabelContext = createContext<string | undefined>(
  undefined,
);
